import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'utils/base-query'
import { BaseCandleDto, BaseCandleFilter, buildQueryString } from '../candles.types'

export { CHSort, CandleInterval } from '../candles.types'

export type BinanceCoin = {
  symbol: string;
  price: number;
}

export type BinanceCandle = BaseCandleDto

export interface BinanceCandleFilter extends BaseCandleFilter {
  symbol: string
}

export const apiBinance = createApi({
  reducerPath: 'apiBinance',
  baseQuery: baseQuery,
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getCoins: builder.query<BinanceCoin[], undefined>({
      query: () => '/binance/coins',
      transformResponse (docs: BinanceCoin[]): BinanceCoin[] {
        return docs
          .map(doc => ({
            symbol: doc.symbol.replace(/USDC/gi, ''),
            price: doc.price
          }))
          // Сортировка по charCodeAt(0) ставила BTC и BNB в произвольном
          // порядке относительно друг друга — сравниваем строки целиком.
          .sort((a, b) => a.symbol.localeCompare(b.symbol))
      }
    }),
    getCandles: builder.query<BinanceCandle[], BinanceCandleFilter>({
      query: ({symbol, startTime, endTime, intervalMs, limit, offset, sort}) =>
        `binance/candles?${ buildQueryString({
          symbol,
          startTime,
          endTime,
          intervalMs,
          limit,
          offset,
          sort
        }) }`
    })
  })
})

export const {
  useGetCoinsQuery,
  useGetCandlesQuery
} = apiBinance
